import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getConversationMessages } from 'api/ai-assistant/ai-assistant-api';

import { AI_ASSISTANT_CONVERSATIONS_KEY } from '../ai-assistant.constants';
import { PENDING_STREAM_POLL_INTERVAL_MS } from '../helpers/pending-stream-helpers';

interface UseApiGetConversationMessagesArgs {
  oktaUserId: string;
  conversationId: string | null | undefined;
  clientId: string | number;
  /** Poll while a MARK reply may still be generating after a page refresh. */
  refetchWhilePending?: boolean;
}

export const useApiGetConversationMessages = ({
  oktaUserId,
  conversationId,
  clientId,
  refetchWhilePending = false,
}: UseApiGetConversationMessagesArgs): UseQueryResult<unknown, unknown> =>
  useQuery({
    queryKey: [
      AI_ASSISTANT_CONVERSATIONS_KEY,
      oktaUserId,
      conversationId,
      clientId,
    ],
    queryFn: () =>
      getConversationMessages({
        oktaUserId,
        conversationId: conversationId as string,
        clientId,
      }),
    enabled: !!oktaUserId && !!conversationId && !!clientId,
    staleTime: 0,
    refetchInterval: refetchWhilePending
      ? PENDING_STREAM_POLL_INTERVAL_MS
      : false,
  });
